import { render, staticRenderFns } from "./showSet.vue?vue&type=template&id=512499f2&scoped=true&"
import script from "./showSet.vue?vue&type=script&lang=js&"
export * from "./showSet.vue?vue&type=script&lang=js&"
import style0 from "./showSet.vue?vue&type=style&index=0&id=512499f2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "512499f2",
  null
  
)

export default component.exports